export interface PlaybackClockAnchor {
  readonly wallTime: number;
  readonly playbackTime: number;
}

export function getPlaybackClockTimestamp(
  clock: PlaybackClockAnchor,
  currentWallTime: number,
  playbackEnd: number,
  sampleIntervalMs: number,
  playbackSpeed: number
): number {
  const elapsedWallTime = Math.max(0, currentWallTime - clock.wallTime);
  const elapsedFrameCount = Math.floor((elapsedWallTime * playbackSpeed) / 1_000);
  const playbackElapsedTime = elapsedFrameCount * sampleIntervalMs;
  return Math.min(clock.playbackTime + playbackElapsedTime, playbackEnd);
}
